export const RECOGNITION = {
  maxImageBytes: 8 * 1024 * 1024,
  maxImageEdge: 1600,
  acceptedMimeTypes: ['image/jpeg', 'image/png', 'image/webp'],
  highConfidence: 0.85,
  candidateConfidence: 0.6,
  weights: { barcode: 1, exactName: 0.9, brandAndPartialName: 0.75, ocrKeyword: 0.22, visual: 0.15, color: 0.05, looseContent: 0.02 }
} as const
